import { DATE_FNS_LOCALES, DEFAULT_LOCALE } from '../constants/i18n';

export function normalizeLocale(locale) {
    const parts = locale.toLocaleLowerCase().replace('_', '-').split('-');

    if (parts.length > 1) {
        return `${parts[0]}-${parts[1].toUpperCase()}`;
    }

    return parts[0];
}

export function getDateFnLocale(locale) {
    const normalizedLocale = normalizeLocale(locale);
    // first, try with the exact locale
    let foundLocale = DATE_FNS_LOCALES.find((l) => l === normalizedLocale);

    if (foundLocale) {
        return foundLocale;
    }

    // then, try finding the more generic one
    foundLocale = DATE_FNS_LOCALES.find((l) => l === normalizedLocale.split('-')[0]);

    if (foundLocale) {
        return foundLocale;
    }

    // otherwise, fall back to 'en'
    return DEFAULT_LOCALE;
}
